import axios from "axios";
import "./interceptors";

// Adapter layer for the global Admin transactions view. The new API
// (`AdminTransactionListRow` / `AdminTransactionsSummary`) is camelCase and
// already returns the charge `amount` in DOLLARS, so the screen renders it
// directly. Pagination meta is reshaped to the legacy `{ totalRecords, ... }`
// the shared <Pagination> component expects.

function toLegacyPagination(meta) {
  return {
    totalRecords: meta.total,
    totalPages: meta.totalPages,
    currentPage: meta.page,
    pageSize: meta.limit,
  };
}

export function getTransactions({ page = 1, pageSize = 10, status = "" } = {}) {
  const params = new URLSearchParams({ page: String(page), limit: String(pageSize) });
  if (status) params.set("status", status);
  const url = `api/v1/admin/transactions?${params.toString()}`;

  return () =>
    axios.get(url).then((res) => ({
      data: res.data.data,
      pagination: toLegacyPagination(res.data.meta),
    }));
}

export function getTransactionsSummary() {
  return () => axios.get(`api/v1/admin/transactions/summary`).then((res) => res.data);
}
